export * from './lib/UiProductWishlistButton';
